import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashLoadingHearth = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M7.67057 8.84256C8.23099 8.07848 8.88092 7.38574 9.60608 6.77344M5.73505 12.7279C5.38479 14.0121 5.23301 15.3704 5.33679 16.7727M10.4351 25.8159C8.62668 24.5653 7.18023 22.8244 6.27604 20.7721M24.7153 25.4479C22.9069 26.8659 20.6744 27.7817 18.2108 27.9659C16.9979 28.0567 15.8135 27.9607 14.6849 27.7077M27.4941 22.2991C28.7071 20.3415 29.3829 18.0259 29.2883 15.552C29.0327 8.92172 23.4532 3.75473 16.8229 4.009M12.3724 16.324C11.7938 14.5144 12.4697 12.4466 14.3689 11.8355C15.3691 11.5151 16.4613 11.6993 17.3007 12.3285C18.1413 11.7045 19.2297 11.5216 20.2273 11.8355C22.1265 12.4466 22.8088 14.5144 22.2289 16.324C21.3273 19.1897 17.3007 21.4003 17.3007 21.4003C17.3007 21.4003 13.3051 19.2235 12.3724 16.324Z",
		stroke: "#596180",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDashLoadingHearth;
